import {
  Errors,
  TravelReservation
} from '@com-delta-idp/mnx-trip-management-shared-ui';

export const TRAVEL_RESERVATION_NO_SEGMENT_ERROR: Errors = {
  code: 'NGTMYTR202',
  message: 'Unable to retrieve reservation',
  moreInfo: [
    {
      developerMessage: 'Lorem ipsum dolor sit amet'
    }
  ]
};

export const TRAVEL_RESERVATION_NO_SEGMENT_RESPONSE: TravelReservation = {
  errors: [TRAVEL_RESERVATION_NO_SEGMENT_ERROR]
} as TravelReservation;
